/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPassportExtraction = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2H3v14h3v4h12.586l-1.293 1.293 1.414 1.414 3-3 .707-.707-.707-.707-3-3-1.414 1.414L18.586 18H8v-2h8V2H4zm1 12V4h9v10H5zm4.5-7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM7 7.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zM7 11v2h5v-2H7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPassportExtraction as PassportExtraction };
